//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LangSelector from "../i18n/lang-selector.vue";
import TermsLinks from "./terms-links.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PageFooter",
  components: {
    TermsLinks,
    LangSelector
  },
  props: {
    showLangSelector: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    mainSiteDomain() {
      return this.$options.filters.mainSiteDomain();
    }
  }
});